class LqdImageTextOverlay extends elementorModules.frontend.handlers.Base {

  onInit(...args) {

    super.onInit(...args);

    this.handleDestroy();

    this.initHover3d();
    this.initInView();
    this.initWebGLHover();

  }

  getDefaultSettings() {
    return {
      selectors: {
        hover3dElement: '[data-hover3d]',
        inViewElement: '[data-inview]',
        webglHoverElement: '[data-webglhover]',
      }
    }
  }

  getDefaultElements() {
    const selectors = this.getSettings('selectors');
    return {
      $hover3dElement: this.$element.find(selectors.hover3dElement),
      $inViewElement: this.$element.find(selectors.inViewElement),
      $webglHoverElement: this.$element.find(selectors.webglHoverElement),
    }
  }

  initHover3d() {

    this.elements.$hover3dElement.liquidHover3d();

  }

  initInView() {

    this.elements.$inViewElement.liquidInView();

  }

  initWebGLHover() {

    this.elements.$webglHoverElement.liquidWebGLHover();

  }

  onDestroy() {

    this.handleDestroy();

    super.onDestroy();

  }

  handleDestroy() {

    this.handleHover3dDestroy();

  }

  handleHover3dDestroy() {

    if ( ! this.elements.$hover3dElement.length ) return;

    const hover3dData = this.elements.$hover3dElement.data('plugin_liquidHover3d');

    if ( hover3dData ) {
      hover3dData.destroy();
    }
  }
  
}

export default ($element) => {
  elementorFrontend.elementsHandler.addHandler( LqdImageTextOverlay, { $element } );
};